module.exports = __webpack_public_path__ + "img/b_Mukoleks_front.6267960d.jpeg";